import { render, staticRenderFns } from "./list_happiness_tips_component.vue?vue&type=template&id=4dd72330&scoped=true"
import script from "./list_happiness_tips_component.vue?vue&type=script&lang=js"
export * from "./list_happiness_tips_component.vue?vue&type=script&lang=js"
import style0 from "./list_happiness_tips_component.vue?vue&type=style&index=0&id=4dd72330&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd72330",
  null
  
)

export default component.exports